module.exports = __webpack_public_path__ + "static/media/iphone-8.79834def.svg";